import { CalculatorConfig } from '@/types/calculator';

// Career Details Calculator Configuration
export const CAREER_DETAILS_CONFIG: CalculatorConfig = {
  id: 'career-details',
  name: 'Career Details',
  title: 'Your Career Path Planner',
  description:
    "Uncover the path to the career you've always wanted.  We'll show you the steps to making your dreams a reality.",
  subhed: 'We recommend the path below to achieve your career goals.',
  formTitle: 'Start by entering your education and career goals:',
  ctaText: 'Discover My Path',
  maxColumns: 3,
  fields: [
    {
      key: 'degree',
      type: 'select',
      label: 'Current Education',
      placeholder: 'Select your current education',
      required: true,
      validation: (value) => !!value || 'Please select your current education',
    },
    {
      key: 'category',
      type: 'select',
      label: 'Field of Study',
      placeholder: 'Select your field of study',
      required: true,
      validation: (value) => !!value || 'Please select your field of study',
      nestedSubjects: true, // Indicates this field should include subjects as nested options
      formatting: (value) =>
        value ? new Intl.NumberFormat().format(value as number) : '',
    },
    {
      key: 'currentRole',
      type: 'select',
      label: 'Current Role',
      placeholder: 'Select your current role',
      required: true,
      validation: (value) => !!value || 'Please select your current role',
    },
    {
      key: 'targetRole',
      type: 'select',
      label: 'Target Role',
      placeholder: 'Select your target role',
      required: true,
      validation: (value) => !!value || 'Please select your target role',
    },
  ],
  tracking: {
    formatSubtype: 'career-pathway-programs',
    location: 'career-pathways',
    formName: 'career-details-calculator',
    formType: 'career-details-calculator',
    name: 'career-details-calculator',
    cardformatSubtype: 'career-pathway-recommendation',
    position: 'career-details-v1',
  },
  defaultValues: {
    degree: '',
    category: '',
    subject: '', // This will be set through nested category selection
    currentRole: '',
    targetRole: '',
  },
  useDynamicDropdowns: true,
};
